//Get Reducer Call--->
export const getLandmarkRequest = (page: number, size: number, search: string) => ({
    type: 'GET_LANDMARK_REQUEST',
    payload: { page, size, search },
});

export const getLandmarkAreaIdRequest = (area_id: string, order_by: string) => ({
    type: 'GET_LANDMARK_AREAID_REQUEST',
    payload: { area_id, order_by },
});

export const getLandmarkSuccess = (data: any) => ({
    type: 'GET_LANDMARK_SUCCESS',
    payload: { data },
});

export const getLandmarkFailure = (data: string) => ({
    type: 'GET_LANDMARK_FAILURE',
    payload: { data },
});

export const resetGetLandmark = () => ({
    type: 'RESET_GET_LANDMARK',
});

//Create Reducer Call--->
export const createLandmarkRequest = (data: any) => ({
    type: 'CREATE_LANDMARK_REQUEST',
    payload: data,
});

export const createLandmarkSuccess = (data: any) => ({
    type: 'CREATE_LANDMARK_SUCCESS',
    payload: { data },
});

export const createLandmarkFailure = (data: string) => ({
    type: 'CREATE_LANDMARK_FAILURE',
    payload: { data },
});

export const resetCreateLandmark = () => ({
    type: 'RESET_CREATE_LANDMARK',
});

//Update Reducer Call--->
export const updateLandmarkRequest = (data: any, id: string) => ({
    type: 'UPDATE_LANDMARK_REQUEST',
    payload: { data, id },
});

export const updateLandmarkSuccess = (data: any) => ({
    type: 'UPDATE_LANDMARK_SUCCESS',
    payload: { data },
});

export const updateLandmarkFailure = (data: string) => ({
    type: 'UPDATE_LANDMARK_FAILURE',
    payload: { data },
});

export const resetUpdateLandmark = () => ({
    type: 'RESET_UPDATE_LANDMARK',
});
//Delete Reducer Call--->
export const deleteLandmarkRequest = (id: string) => ({
    type: 'DELETE_LANDMARK_REQUEST',
    payload: { id },
});

export const deleteLandmarkSuccess = (data: any) => ({
    type: 'DELETE_LANDMARK_SUCCESS',
    payload: { data },
});

export const deleteLandmarkFailure = (data: string) => ({
    type: 'DELETE_LANDMARK_FAILURE',
    payload: { data },
});

export const resetDeleteLandmark = () => ({
    type: 'RESET_DELETE_LANDMARK',
});
